import { RequestConfig } from '../types';

export function handleSuccessNotification<T>(
  result: T,
  config: RequestConfig,
  notify: (message: string) => void
) {
  if (!config.notify?.success) return;

  const message = (result as any)?.message ?? 'Операция выполнена!';

  notify(message);
}
